// ────────────────────────────────────────────────────────────────────────────
// Configuration légale & business — source de vérité
// Informations issues du document officiel INPI / Guichet unique des entreprises
// (Formalité J00242599280 — validée le 12/06/2026)
// ────────────────────────────────────────────────────────────────────────────

export const legalConfig = {
  // ── Identité publique ──
  brandName: "Louis-Melchior Danse",
  publisherFullName: "Louis-Melchior Antoine Marie Giraud",
  publisherName: "Louis-Melchior Giraud",
  publicationDirector: "Louis-Melchior Giraud",
  legalForm: "Entrepreneur individuel",

  // ── Coordonnées ──
  contactEmail: "louismelchiorgiraud@icloud.com",
  contactPhone: "+33 7 81 87 16 89",
  contactPhoneE164: "+33781871689",
  websiteUrl: "https://louismelchiordanse.com",
  domain: "louismelchiordanse.com",

  // ── Identifiants officiels ──
  siren: "106 263 247",
  sirenRaw: "106263247",
  siret: "106 263 247 00012",
  siretRaw: "10626324700012",
  apeCode: "8552Z",
  apeLabel: "Enseignement culturel",
  registrationAuthority: "Registre national des entreprises (RNE)",
  registrationDate: "12/06/2026",
  activityStartDate: "16/05/2026",

  // ── Adresse juridique (à utiliser UNIQUEMENT en pages légales) ──
  legalAddress: {
    line1: "26 rue du Maréchal Foch",
    postalCode: "57390",
    city: "Audun-le-Tiche",
    country: "France",
    countryCode: "FR",
  },

  // ── Activité ──
  activityNature: "Activité libérale non réglementée",
  activityDescription:
    "Enseignement de la danse sous forme de cours particuliers et collectifs, pour adultes, couples, groupes et débutants : valse, rock, rock acrobatique, danse de salon, danse de mariage et autres danses de loisir. Préparation d'ouvertures de bal, accompagnement de couples avant un mariage, initiation, perfectionnement, ateliers et animations.",
  activities: [
    "Rock",
    "Valse",
    "Rock acrobatique",
    "Danse de salon",
    "Danse de mariage",
    "Line dance",
  ],
  serviceArea: ["Luxembourg", "France"],
  serviceAreaLabel: "France et Luxembourg",

  // ── Fiscalité ──
  taxRegime: "Régime spécial BNC",
  vatRegime: "Franchise en base de TVA",
  vatMention: "TVA non applicable, article 293 B du Code général des impôts",

  // ── Hébergement (à compléter par Louis-Melchior si une vérification supplémentaire est souhaitée) ──
  hosting: {
    name: "Emergent",
    legalForm: "Société exploitant la plateforme emergent.sh",
    address: "Coordonnées disponibles sur emergent.sh",
    website: "https://emergent.sh",
    contact: "Voir emergent.sh",
  },

  // ── Sous-traitants techniques réels ──
  technicalProviders: {
    hosting: "Emergent (emergent.sh)",
    database: "MongoDB Atlas (gérée par l'hébergeur)",
    emailDelivery: "Resend (resend.com) — Resend Inc., 2261 Market Street, San Francisco, CA 94114, USA",
    aiAssistant: "OpenAI (assistant conversationnel optionnel)",
  },

  // ── Médiateur de la consommation (à compléter après adhésion) ──
  // ⚠️ Obligation légale pour les pros vendant des services aux consommateurs.
  // Tant que la souscription n'est pas effective, ne pas afficher de fausses coordonnées.
  consumerMediator: {
    designated: false,
    name: null,
    address: null,
    website: null,
    referenceNumber: null,
  },

  // ── Tarifs (source unique) ──
  pricing: {
    hourly: "80 € / heure",
    hourlyNumber: 80,
    pack5: "Pack 5 heures : 370 €",
    pack5Number: 370,
    pack10: "Pack 10 heures : 720 €",
    pack10Number: 720,
    travel: "Déplacement : +10 € selon localisation",
    currency: "EUR",
  },

  // ── Réseaux & profils officiels ──
  social: {
    instagram: "https://www.instagram.com/louismelchiordanse/",
    facebook: "https://www.facebook.com/share/14a7zKs5b5L/?mibextid=wwXIfr",
    googleReview: "https://g.page/r/CWvxlo82U0m1EAE/review",
  },
};
